import { render, staticRenderFns } from "./SettingMobileIntro.vue?vue&type=template&id=2f7baba6&scoped=true"
import script from "./SettingMobileIntro.vue?vue&type=script&lang=js"
export * from "./SettingMobileIntro.vue?vue&type=script&lang=js"
import style0 from "./SettingMobileIntro.vue?vue&type=style&index=0&id=2f7baba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7baba6",
  null
  
)

export default component.exports